const NeuralSearchIcon = () => (
  <svg
    version="1.1"
    id="icon"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="36px"
    viewBox="0 0 36 36"
    xmlSpace="preserve"
  >
    <circle
      fill="#D3CFFF"
      stroke="unset"
      className="u-no-animation"
      cx="18"
      cy="18"
      r="18"
    />
    <path
      fill="#2B140E"
      d="M29.14654,28.94732c-0.55823,0.55823-1.46326,0.55823-2.02148,0l-3.55969-3.55969
	c0.75677-0.58618,1.435-1.26514,2.02057-2.0224l3.56061,3.56061C29.70477,27.48406,29.70477,28.38909,29.14654,28.94732z
	 M16.71246,26.74279c-5.646,0-10.22296-4.57697-10.22296-10.22296c0-5.64594,4.57697-10.2229,10.22296-10.2229
	s10.22296,4.57697,10.22296,10.2229C26.93542,22.16583,22.35846,26.74279,16.71246,26.74279z M25.38427,16.51995
	c0-4.78174-3.89062-8.67188-8.67188-8.67188s-8.67188,3.89014-8.67188,8.67188c0,4.78125,3.89062,8.67188,8.67188,8.67188
	S25.38427,21.3012,25.38427,16.51995z M24.38427,16.51995c0,4.23047-3.44141,7.67188-7.67188,7.67188
	s-7.67188-3.44141-7.67188-7.67188s3.44141-7.67188,7.67188-7.67188S24.38427,12.28948,24.38427,16.51995z M17.8081,19.99456
	l-2.8797-4.16724l2.59747-2.66284c0.19238-0.19775,0.18848-0.51416-0.00879-0.70703
	c-0.19727-0.19141-0.5127-0.18896-0.70801,0.00879l-3.3125,3.39587v-3.04675c0-0.27637-0.22363-0.5-0.5-0.5s-0.5,0.22363-0.5,0.5
	v4.28143c0,0.00043-0.00006,0.00085,0,0.00128v3.18066c0,0.27637,0.22363,0.5,0.5,0.5s0.5-0.22363,0.5-0.5v-2.98352l0.72064-0.73883
	l2.76862,4.00653c0.09668,0.14062,0.25293,0.21582,0.41113,0.21582c0.09863,0,0.19727-0.02832,0.28418-0.08887
	C17.90869,20.53265,17.96533,20.2221,17.8081,19.99456z M20.9956,12.81536c0-0.27637-0.22363-0.5-0.5-0.5s-0.5,0.22363-0.5,0.5
	v7.46338c0,0.27637,0.22363,0.5,0.5,0.5s0.5-0.22363,0.5-0.5V12.81536z"
    />
  </svg>
)

export default NeuralSearchIcon
